import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { App, URLOpenListenerEvent } from '@capacitor/app';
import { supabase } from '@/integrations/supabase/client';

export const useDeepLinks = () => {
  const navigate = useNavigate();

  useEffect(() => {
    // Check if running in Capacitor
    const isCapacitor = window.location.protocol === 'capacitor:' || 
                        (window as any).Capacitor?.isNativePlatform?.();
    
    if (!isCapacitor) return;

    // Handle deep links when app is opened via URL
    const handleAppUrlOpen = async (event: URLOpenListenerEvent) => {
      const url = new URL(event.url);
      
      // Handle OAuth callback
      if (url.hash && url.hash.includes('access_token')) {
        // Parse the hash fragment for Supabase auth
        const hashParams = new URLSearchParams(url.hash.substring(1));
        const accessToken = hashParams.get('access_token');
        const refreshToken = hashParams.get('refresh_token');
        
        if (accessToken && refreshToken) {
          await supabase.auth.setSession({
            access_token: accessToken,
            refresh_token: refreshToken,
          });
          navigate('/swipe');
        }
      } else {
        // Handle other deep link paths
        const path = url.pathname || '/';
        navigate(path);
      }
    };

    App.addListener('appUrlOpen', handleAppUrlOpen);

    return () => {
      App.removeAllListeners();
    };
  }, [navigate]);
};
